import {
    buildLoadTiles,
    buildLogisticsTypeTiles,
    buildRouteTiles,
    EmissionsExplanationSection,
    InputsWrapper,
    Leg,
    LogisticsAdditionalDetails,
    ResultLabeledSectionAndTiles,
} from '@lune-fe/lune-components-lib'
import { Box } from '@mui/material'

import Divider from 'components/Divider'

const MultiLegItem = ({
    activeLeg,
    activeTabIndex,
    pdfStructure,
    load,
    activeLegFormattedAmount,
    requestRoute,
}: {
    activeLeg: Leg
    activeTabIndex: string
    load: any
    pdfStructure?: boolean
    activeLegFormattedAmount: any
    requestRoute: any
}) => {
    return (
        <>
            <EmissionsExplanationSection
                pdfStructure={pdfStructure}
                legIndex={activeTabIndex}
                dataQualityScore={activeLeg.dataQualityScore}
                emissions={activeLeg.mass}
                emissionsUnit={activeLegFormattedAmount.amountUnit}
                emissionFactor={activeLeg.emissionFactor}
                methodology={activeLeg.methodology}
                rawDistance={activeLeg.rawDistance}
                distance={activeLeg.distance}
                adjustedDistance={activeLeg.adjustedDistance}
                load={load}
                distanceCalculationMethod={activeLeg.distanceCalculationMethod}
                distanceCalculationDetails={activeLeg.distanceCalculationDetails}
                loadConversionMethod={activeLeg.shipmentConversionMethod}
                convertedLoad={activeLeg.convertedShipment}
                requestRoute={activeLeg.route ?? null}
                requestMethod={activeLeg.method}
                responseRoute={activeLeg.responseRoute}
                methodologyDetails={activeLeg.methodologyDetails}
                vesselInference={activeLeg.vesselInferenceDetails ?? null}
                routeInferenceLegExplanation={activeLeg.routeInferenceDetails}
                mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
                inferenceDetails={activeLeg.inferenceDetails}
            />
            <Divider />
            <Box>
                <InputsWrapper>
                    <ResultLabeledSectionAndTiles
                        tiles={[
                            ...buildLogisticsTypeTiles(activeLeg.method, activeLeg.emissionFactor),
                            ...(requestRoute ? buildRouteTiles(requestRoute) : []),
                            ...(activeLeg.route && !requestRoute
                                ? buildRouteTiles(activeLeg.route)
                                : []),
                            ...buildLoadTiles(load, activeLeg.emissionFactor.denominatorUnit),
                        ]}
                        dataTestId={'leg-shipping-method'}
                    />
                </InputsWrapper>
            </Box>
            {(activeLeg.activity || activeLeg.intensity) && (
                <>
                    <Divider />
                    <Box>
                        <LogisticsAdditionalDetails
                            activity={activeLeg.activity}
                            intensity={activeLeg.intensity}
                            method={activeLeg.method}
                        />
                    </Box>
                </>
            )}
        </>
    )
}

export default MultiLegItem
